exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ias-styles-root #teamMembersContainer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  height: 150px; }\n  .ias-styles-root #teamMembersContainer > textarea {\n    -ms-flex-item-align: stretch;\n    align-self: stretch;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1; }\n", ""]);

// exports
